<template>
    <div
        :class="['visual-canvas', modify]"
        :style="[{'width': width},{'height': height}]"
      >
        <transition name="fade">
            <svg v-if="dataStep.step !== 'flat' && dataStep.step !== 'parking'"
             class="visual-canvas__svg"
             :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
             preserveAspectRatio="xMidYMid slice"
             ref="svg"
        >
            <image x="0" y="0" width="100%" height="100%" :xlink:href=render.link></image>

            <rect
                v-if="dataStep.step !== 'parking'"
                class="visual-canvas__overlay" width="100%" height="100%"
                :fill-opacity="overlay"
                mask="url(#visual-canvas__hole)"
            >
            </rect>

            <path
                v-for="element in elements" :key="element.id"
                :class="['visual-canvas__path', {'is-booked': element.isBooked, 'is-sold': element.status === 'sold',}]"
                :id=element.id
                :d=element.path
                :link=element.link
                ref="masks"
                :fill="[element.fill ? element.fill : $appOptions.fill]"
                @mouseover="mouseOverHandler(element.id, element.link, 'flats', false, $event)"
                @mousemove="mouseMoveHandler"
                @mouseleave="mouseLeaveHandler"
                @click="clickHandler(element.link)"
            >
            </path>


            <defs>
                <mask id="visual-canvas__hole">
                    <rect fill="white" width="100%" height="100%"></rect>
                    <path v-for="element in elements" :key="element.id" :d=element.path></path>
                </mask>
            </defs>
        </svg>
        </transition>

        <transition name="fade">
            <PanZoom :options="options" @registerSvgPanZoom="registerSvgPanZoom" v-if="dataStep.step === 'parking'">
                <svg 
                    class="visual-canvas__svg"
                    :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
                    preserveAspectRatio="xMidYMid meet"
                    ref="svg"
                >
                    <image x="0" y="0" width="100%" height="100%" :xlink:href=render.link></image>

                    <rect
                        v-if="dataStep.step !== 'parking'"
                        class="visual-canvas__overlay" width="100%" height="100%"
                        :fill-opacity="overlay"
                        mask="url(#visual-canvas__hole)"
                    >
                    </rect>

                    <path
                        v-for="parking in parkings" :key="parking.id"
                        :class="['visual-canvas__path', {'is-booked': parking.isBooked, 'is-sold': parking.isSold}]"
                        :id=parking.id
                        :d=parking.path
                        :link=parking.link
                        ref="masks"
                        :fill="[parking.fill ? parking.fill : $appOptions.fill]"
                        @mouseover="mouseOverHandler(parking.id, parking.link, dataStep.step, parking.isSold, $event)"
                        @mousemove="mouseMoveHandler"
                        @mouseleave="mouseLeaveHandler"
                        @click="clickParking(parking.id, parking.title, parking.isBooked, parking.isSold)"
                    >
                    </path>


                    <defs>
                        <mask id="visual-canvas__hole">
                            <rect fill="white" width="100%" height="100%"></rect>
                            <path v-for="parking in parkings" :key="parking.id" :d=parking.path></path>
                        </mask>
                    </defs>
                </svg>
            </PanZoom>
        </transition>

        <transition name="fade" mode="out-in" appear>
            <svg v-if="dataStep.step === 'flat'"
             class="visual-canvas__svg"
             :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
             preserveAspectRatio="xMidYMid"
             ref="svg"
        >
            <!-- Обязательно оставить, порядок важден для положения масок -->
            <image x="0" y="0" width="100%" height="100%" :xlink:href=render.link></image>

            <path
                v-for="element in elements" :key="element.id"
                :class="['visual-canvas__path', {
                    'is-booked': element.tooltip.status === 'booked',
                    'is-sold': element.tooltip.status === 'sold',
                    'is-not-sale': element.tooltip.status === 'notSale'
                }]"
                :id=element.id
                :d=element.path
                :link=element.link
                ref="masks"
                :fill="[element.fill ? element.fill : $appOptions.fill]"
                @mouseover="mouseOverHandler(element.id, element.link, 'flats', false, $event)"
                @mousemove="mouseMoveHandler"
                @mouseleave="mouseLeaveHandler"
                @click="clickHandler(element.link, element.tooltip.status,  $event)"
            >
            </path>
        </svg>
        </transition>
        <slot name="pointer"></slot>
        <slot name="infrastructure"></slot>
        <slot name="panorama"></slot>

    </div>
</template>

<style lang='scss'>
    @import "./Canvas.scss";
</style>

<script>
import Hammer from 'hammerjs';
import {mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import PanZoom from '../Parking/PanZoom/PanZoom';
import Select from 'components/forms/select/select-vue.vue';
import Utils from 'common/scripts/utils';

const observer = new Observer();

export default {
    props: ['modify'],

    data() {
        return {
            overlay   : this.$appOptions.overlay.default,
            width     : '',
            height    : '',
            clickCount: 0,
            svgpanzoom: null,
            options   : {
                setMinZoom: true,
                minZoom   : 0.85
            }
        };
    },

    components: {
        PanZoom,
        Select
    },

    computed: {
        ...mapGetters({
            renderSize: 'GET_CANVAS_SIZE',
            render    : 'GET_RENDER',
            rotate    : 'GET_ROTATE',
            elements  : 'GET_ELEMENTS',
            dataStep  : 'GET_DATA_STEP',
            parkings  : 'GET_PARKINGS',
            buildings : 'GET_BUILDING'
        })
    },

    watch: {
        rotate() {
            this.setCanvasSize();
        }
    },

    beforeCreate() {
        observer.unsubscribe('clicknextPanel');
    },

    created() {
        this.setOverlayOpacity();
        this.bindEvents();
        this.subscribes();
        this.setCanvasSize();
    },

    methods: {
        setCanvasSize() {
            const params = {
                width : `${100}%`,
                height: `${100}%`,
                scale : Number(this.render.scale) || 1
            };
            const widthRatio = window.screen.height * 16 / 9;

            if (!Utils.isBreakpoint(0, 960)) {
                this.width = params.width;
                this.height = params.height;
                this.scrollToCenter();

                return;
            }

            if (this.dataStep.step === 'flat') {
                if (window.outerWidth < widthRatio) {
                    const scale = 1.5;

                    this.width = `${window.screen.width * scale}px`;
                    this.height = `${window.screen.height * scale}px`;
                }

                return;
            }

            // если ширина экрана не позволяет вписать полностью рендер, то тянем его в пропорции 16/9
            if (window.outerWidth < widthRatio) {
                this.width = `${widthRatio * params.scale}px`;
                this.height = `${window.screen.height * params.scale}px`;
                this.scrollToCenter();
            } else {
                this.width = params.width;
                this.height = params.height;
            }
        },

        scrollToCenter() {
            let renderPosition = parseFloat(this.width.replace(/[^\d.]/ig, '')) / 2;
            const scrollFrame = document.querySelector('.visual');

            renderPosition = renderPosition - (window.outerWidth / 2);

            this.$nextTick(() => {
                scrollFrame.scrollTo({
                    left    : renderPosition,
                    behavior: 'smooth'
                });
            });
        },

        bindEvents() {
            window.addEventListener('resize', this.setCanvasSize.bind(this));
        },

        registerSvgPanZoom(svgpanzoom) {
            this.svgpanzoom = svgpanzoom;

            this.setPathEventsHandler();
        },

        setPathEventsHandler() {
            Array.from(this.$refs.path).forEach((path) => {
                if (path.hasAttribute('init')) {
                    return;
                }

                path.setAttribute('init', 'true');

                new Hammer(path).on('tap', () => {
                    const activeElement = this.elements.find((element) => {
                        return `path-${element.id}` === path.id;
                    });

                    if (this.isMobile()) {
                        this.activeElement = this.activeElement === activeElement ? null : activeElement;
                    } else {
                        this.clickPath(activeElement);
                    }
                });
            });
        },

        subscribes() {
            observer.subscribe('clicknextPanel', (link) => {
                this.route(link);
            });
        },

        mouseOverHandler(id, link, step, sold = true, event) {
            this.overlay = this.$appOptions.overlay.hover;
            // this.movingPath(event);

            if (!sold) {
                if (Utils.isBreakpoint(0, 1280)) {
                    const panel = document.querySelector('.visual-panel');

                    if (panel) {
                        observer.publish('mouseleavePanel');
                    }

                    observer.publish('mouseoverPanel', {
                        id,
                        link,
                        event,
                        elements: this.elements,
                        type    : step
                    });
                } else {
                    observer.publish('mouseoverTooltip', {
                        id,
                        event,
                        elements: this.elements,
                        type    : step
                    });
                }
            }
        },

        mouseMoveHandler(event) {
            if (!Utils.isBreakpoint(0, 1280)) {
                observer.publish('mousemoveTooltip', event);
            }
        },

        mouseLeaveHandler() {
            this.overlay = this.dataStep.step === 'floor' ?
                this.$appOptions.overlay.floor :
                this.$appOptions.overlay.default;

            if (!Utils.isBreakpoint(0, 1280)) {
                observer.publish('mouseleaveTooltip');
            }
        },

        clickHandler(link, element, event) {
            if (Utils.isBreakpoint(0, 1280)) {
                this.clickCount = this.clickCount + 1;
                if (this.clickCount % 2 === 0) {
                    this.route(link);
                }
            } else if (element === 'sold' || element === 'notSale' || element === 'booked') {
                event.preventDefault();
            } else {
                observer.publish('mouseclickTooltip');
                this.route(link);
            }
        },

        clickParking(element, title, booked, sold) {
            if (!booked && !sold) {
                if (!Utils.isBreakpoint(0, 1280)) {
                    observer.publish('parkingClick', {
                        element,
                        title
                    });
                }
            }
        },

        movingPath(event) {
            const target = event.currentTarget;
            const svg = this.$refs.svg;

            event.currentTarget.style.display = 'none';

            svg.insertAdjacentHTML('afterbegin', target.outerHTML);
        },

        route(link) {
            if (this.dataStep.step === 'flat') {
                window.location = link;
            } else {
                this.$router.push(link);
            }
        },

        setOverlayOpacity() {
            this.overlay = this.dataStep.step === 'floor' ?
                this.$appOptions.overlay.floor :
                this.$appOptions.overlay.default;
        }
    }
};
</script>
